/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, signal} from '@angular/core';

import {AdnTranslateService} from '../common/filters/adn-translate.service';
import template from './site-creative-summary.component.html';
import {SiteCreativeSummaryItem} from './site-api.service';
import {SiteCreativeSummaryState} from './site-creative-summary-state';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-site-creative-summary',
  template
})
export class SiteCreativeSummaryComponent {
  @Input() state: SiteCreativeSummaryState;
  @Input() summaryLabel = 'creatives';
  @Input() emptyMessage = 'No creatives found.';
  @Input() admin = false;

  readonly expanded = signal(false);

  constructor(private readonly adnTranslate: AdnTranslateService) {
  }

  toggleExpanded(event: Event): void {
    event.preventDefault();
    this.expanded.update((expanded) => !expanded);
  }

  trackCreative(index: number, creative: SiteCreativeSummaryItem): string {
    const key = (creative.creative?.id || 'unknown-creative')
      + ':' + (creative.lineItem?.id || 'unknown-line-item')
      + ':' + (creative.hash || '');
    return creative.creative?.id && creative.lineItem?.id ? key : key + ':' + index;
  }

  translateViolation(violation: any): string {
    return this.adnTranslate.transform(violation.text, violation.code, violation.parameters);
  }
}
